import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const richContentViewer: DataBindingComponentModel = {
  panel: {
    height: 250,
    title: 'wixui_RichContentViewer_dataBinding_panelTitle',
    helpId: '',
  },
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'richContentRole',
      bindings: [
        {
          title: 'wixui_RichContentViewer_dataBinding_value_label',
          prop: 'content',
          supportedFieldTypes: [FieldType.richContent],
          defaultFieldType: FieldType.richContent,
          requiresPrimaryConnection: true,
        },
      ],
      manifest: {
        gfpp: {
          desktop: {
            mainAction2: {
              label: 'wixui_RichContentViewer_dataBinding_gfpp_manage',
              actionId: 'wixui_RichContentViewer_dataBinding_gfpp_manage',
            },
          },
        },
      },
      manageContentPanel: {
        description: 'wixui_RichContentViewer_dataBinding_gfpp_manage',
      },
    },
  ],
  compactErrorPanel: true,
}
